// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b9fdb45b","239":"08d2b0b1","732":"29b301c4"}[chunkId] + ".chunk.js";
};